import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "subjects",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "subjects" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
